import { render, staticRenderFns } from "./VehiclesView.vue?vue&type=template&id=6a7c8e61&"
import script from "./VehiclesView.vue?vue&type=script&lang=ts&"
export * from "./VehiclesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports